var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-bottom": "2rem" } },
    [
      _c(
        "h2",
        [
          _c("Label", { attrs: { characteristic: _vm.item.item } }),
          _vm._v(" "),
          _vm.getSupplements(_vm.item)
            ? [_vm._v("(" + _vm._s(_vm.getSupplements(_vm.item)) + ")")]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("Edit", {
        staticClass: "pl-5",
        attrs: {
          item: _vm.item,
          "experience-config": _vm.experienceConfig,
          "self-assessment-config": _vm.selfAssessmentConfig,
          "education-config": _vm.educationConfig,
          type: _vm.type
        },
        on: { change: _vm.onChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }